<div class="main-section loader-page">
    <div class="content-wrapper">
        <img src="https://images.5paisa.com/SPOT/activation/timer.svg" alt="loader" />
        <h1>{{min+":"+sec}}</h1>
        <p>Please wait...We are analysing the bank statement</p>
    </div>
</div>